import widgetRoutes from 'enums/routes'
import { useRouter } from 'next/router'
import { useEnthusiast } from 'shared/state/useAuth'

/**
 * If user signs out while on the config or review pages and the schedulable is members only
 * this will re-route user so they cant continue flow
 */

const useRedirectUnauthenticatedOnSchedulableMembersOnly = ({
  schedulableIsMembersOnly
}: {
  schedulableIsMembersOnly: boolean
}) => {
  const { authenticated } = useEnthusiast()
  const { query, push } = useRouter()
  const widgetSlug = query.widgetSlug as string

  if (!authenticated && schedulableIsMembersOnly) {
    push(widgetRoutes.HOME.url({ widgetSlug }))
  }
}

export default useRedirectUnauthenticatedOnSchedulableMembersOnly
